import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, TitleStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NbMenuModule, NbSidebarModule } from '@nebular/theme';
import { NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreModule } from '@ngrx/store';
import { ToastsModule } from '@tgx/shared/toasts';
import { AutoCompleteModule } from '@openng/optimus-ui/autocomplete';
import { SelectModule } from '@openng/optimus-ui/select';
import { environment } from './../../../../environments/environment';
import { CoreModule } from './@core/core.module';
import { AccessTokenInterceptor } from './@core/interceptors/_index.interceptors';
import { SharedModule } from './@core/shared/shared.module';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StaffGuard } from './@core/guards/staff.guard';
import { BillingModule } from './features/billing/billing.module';
import { EntitiesModule } from './features/entities/entities.module';
import { ApplicationsModule } from './features/applications/applications.module';
import { NetworkModule } from './features/network/network.module';
import { ContentModule } from './features/content/content.module';
import { WebModule } from './features/web/web.module';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { AppsModule } from './features/apps/apps.module';
import { MappingModule } from './features/mapping/mapping.module';
import { UtilitiesModule } from './features/utilities/utilities.module';
import { SharedUiStorybookModule } from '@tgx/shared/ui/storybook';
import { SharedUiStylesModule } from '@tgx/shared/ui/styles';
import { HttpHeadersInterceptor } from '@tgx/shared/data-access/interceptors';
import { AdminTitleStrategy } from './@core/strategies/admin-title.strategy';
import { AUTH0_CLIENT_ID, AUTH0_DOMAIN } from '@tgx/shared/services';

@NgModule({
  declarations: [AppComponent],
  imports: [
    ToastsModule,
    RouterModule,
    CommonModule,
    SelectModule,
    AutoCompleteModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    SharedUiStorybookModule,
    SharedUiStylesModule,
    NgbModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    StoreModule.forRoot(
      {},
      {
        metaReducers: !environment.production ? [] : [],
      },
    ),
    CoreModule,
    DashboardModule,
    BillingModule,
    EntitiesModule,
    ApplicationsModule,
    AppsModule,
    NetworkModule,
    MappingModule,
    UtilitiesModule,
    ThemeModule.forRoot(),
    NgbPopoverModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    CoreModule.forRoot().providers,
    BillingModule.forRoot().providers,
    EntitiesModule.forRoot().providers,
    AppsModule.forRoot().providers,
    NetworkModule.forRoot().providers,
    ContentModule.forRoot().providers,
    WebModule.forRoot().providers,
    ApplicationsModule.forRoot().providers,
    //AdminModule.forRoot().providers,
    {
      provide: AUTH0_DOMAIN,
      useValue: environment.auth0.domain,
    },
    {
      provide: AUTH0_CLIENT_ID,
      useValue: environment.auth0.clientId,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpHeadersInterceptor, multi: true },
    { provide: TitleStrategy, useExisting: AdminTitleStrategy },
    StaffGuard,
    provideZoneChangeDetection(),
  ],
  exports: [HttpClientModule],
})
export class AppModule {}
